// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldBinaryOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldBinaryOutlined";
import AntdIcon from '../components/AntdIcon';

var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldBinaryOutlinedSvg
  }));
};

FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
export default React.forwardRef(FieldBinaryOutlined);